import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CountryTimezoneComponent } from './country-timezone/country-timezone.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { FormatKwhPipe, FormatMinutesPipe, FormatPercentPipe, FormatMpmPipe, FormatWeekdaysPipe, periodFunctionDesc, PeriodFunctionPipe } from './shared-pipes';
import { ReloadErrorComponent } from './reload-error/reload-error.component';
import { RouterModule } from '@angular/router';
import { UpgradePlanComponent } from './upgrade-plan/upgrade-plan.component';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { TimePickerComponent } from './time-picker/time-picker.component';
import { HomeBatteryComponent } from './home-battery/home-battery.component';
import { TooltipComponent } from './tooltip/tooltip.component';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    IonicModule,
  ],
  declarations: [
    CountryTimezoneComponent,
    ReloadErrorComponent,
    UpgradePlanComponent,
    FormatMinutesPipe,
    FormatKwhPipe,
    FormatPercentPipe,
    FormatMpmPipe,
    FormatWeekdaysPipe,
    HomeBatteryComponent,
    PeriodFunctionPipe,
    TimePickerComponent,
    TooltipComponent,
  ],
  providers: [
    InAppBrowser,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    CountryTimezoneComponent,
    ReloadErrorComponent,
    UpgradePlanComponent,
    FormatMinutesPipe,
    FormatKwhPipe,
    FormatPercentPipe,
    FormatMpmPipe,
    FormatWeekdaysPipe,
    HomeBatteryComponent,
    PeriodFunctionPipe,
    TimePickerComponent,
    TooltipComponent,
  ],
})
export class SharedModule { }
